export default __webpack_public_path__ + "static/media/pot1.3a1b1131.svg";